import './App.scss';
import React from 'react';
import Web3 from 'web3'; 
import { chainMap, enforceChain } from './tools/ChainTools.js'
import { tokens } from './configs/CultTokensConfig.js'
import { nfts } from './configs/CultNFTConfig.js'

import door from './images/forge.png'
import famgif from './imgs/famsmooth.gif'
import fam1 from './imgs/fam1.png'

import resource__dust from './images/dust.png'
import resource__rock from './images/rock.jpg'
import resource__karma from './images/karma.jpg'

import crystal__fam from './images/famcrystal.jpg'
import crystal__karma from './images/karmacrystal.jpg'
import crystal__chalk from './images/chalk.jpg'


import tokenImg__fam from './imgs/fam1.png'

import pending from './images/pending.gif'

import ItemShop from './itemshop.js'

import { Pool, getUserInfo, getPendingCandle } from './pool.js'

import { Shrines, shrineNames } from './shrine.js'

const f = new Intl.NumberFormat('en-US')

const farms = {
  "burn": {
    "address": "0xc450a27A9BDAB9557304C8cF8C71f18Afd2ba642",
    "abi": require("./abis/MatchbookFarms.json")
  },
  "gate": {
    "address": "0xACc1c939b42A1a0e68C2975aB7B46BD8D168126C",
    "abi": require("./abis/CandleGatedChef.json")
  }, 
  "degenesis": {
    "address": "0x2462FA2Bc4B0Cbc501c8546081556fF4F84162De",
    "abi": require("./abis/CandleDegenesisABI.json")
  }
}

const MINING_DELAYS = [0,10000,1000,1]
const RES_NAMES = ["","Karma","Familiar Dust","Sacred Rock"]
const fs = (bal, dec = 18) => {
  let x = (typeof(bal) == "undefined")? "" : bal.toString()
  let digits, decimals
  let L = "0", R = "0"
  let output
  //console.log(x.length, dec)
  if (x.length > dec) {
    digits = x.length - dec
    L = x.slice(0,digits)
    R = x.slice(digits)
  } else {
    decimals = dec - x.length
    R = "0".repeat(decimals).concat(x)
  }
  output = L.concat(".").concat(R)
  //console.log(output)
  output = new Intl.NumberFormat().format(output)
  return output
}
function App() {
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----
  // Connecting to Metamask
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----
  const [connected, setConnected] = React.useState(false)
  const [accounts, setAccounts] = React.useState([])
  const [mmBtnText, setMMBtnText] = React.useState("Connect")
 
  // attached to the accountsChanged event listener
  // triggered once manually via connectMM
  function handleNewAccounts(newAccounts) {
    setAccounts(newAccounts);
  }

  // attached to the chainChanged event listener
  // triggered once manually via main hook
  // calls letItRip if the proper chain is selected
  function handleChainChange(chainId) {
    setMMBtnText("Connected to " + chainMap(window.ethereum.chainId));
     enforceChain("Fantom", letItRip)
  }

  // when triggered, connectMM requests the user connects to the dApp
  // if the user is already connected, or after the user connects,
  // connectMM sets the accounts state to the user's connected accounts,
  // and sets the connected state to true
  const connectMM = () => {
    if (!connected) {
      window.ethereum
        .request({ method: 'eth_requestAccounts' })
        .then((newAccounts) => {
          handleNewAccounts(newAccounts)
          setConnected(true)})
    }
  }

  
  React.useEffect(() => {
    if (connected) {
      window.ethereum.on('accountsChanged', handleNewAccounts);
      window.ethereum.on('chainChanged', handleChainChange);
      return () => {
        window.ethereum.on('accountsChanged', handleNewAccounts);
        window.ethereum.on('chainChanged', handleChainChange);
      };
    }
  }, [connected]);



  
  // --------- -------------------------------------------------------------------------------
  // MAIN HOOK -------------------------------------------------------------------------------
  // --------- -------------------------------------------------------------------------------

  // if a user is connected with at least one account,
  // trigger the handleChainChange function
  React.useEffect( () => {
    if (connected) {
        if (accounts.length > 0) {
          handleChainChange(window.ethereum.chainId)  
        }
      }
  }, [connected])



  // --------- -------------------------------------------------------------------------------

  // -- end of connecting to metamask
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----

  

  const [isDisabled, setDisabled] = React.useState(false);

  // this is a reference to the input field
  const theInputRef = React.createRef();

  // state for managing whether a transaction is pending
  const [isPending, setIsPending] = React.useState(false);
  const [pendingText, setPendingText] = React.useState("Pending Transaction")

  // initialize web3 
  const web3 = new Web3(new Web3.providers.HttpProvider('https://rpc.ftm.tools'));

  // initialize contracts ERC20
  var candle = new web3.eth.Contract(tokens["candle"]["abi"], tokens["candle"]["address"])
  var cult = new web3.eth.Contract(tokens["cult"]["abi"], tokens["cult"]["address"])
  var xcult = new web3.eth.Contract(tokens["xcult"]["abi"], tokens["xcult"]["address"])
  
  // initialize contracts ERC721
  var skullys = new web3.eth.Contract(nfts["skullys"]["abi"], nfts["skullys"]["address"])
  var pops = new web3.eth.Contract(nfts["popskullys"]["abi"], nfts["popskullys"]["address"])
  var ghostly = new web3.eth.Contract(nfts["ghostlys"]["abi"], nfts["ghostlys"]["address"])

  // initialize contracts ERC1155
  var items = new web3.eth.Contract(nfts["items"]["abi"], nfts["items"]["address"])
  var resources = new web3.eth.Contract(nfts["resources"]["abi"], nfts["resources"]["address"])
  var crystals = new web3.eth.Contract(nfts["crystals"]["abi"], nfts["crystals"]["address"])
  var shrine_crystals = new web3.eth.Contract(nfts["shrineCrystals"]["abi"], nfts["shrineCrystals"]["address"])


  // initialize contracts other
  var fdf = new web3.eth.Contract(nfts["famdustfarm"]["abi"], nfts["famdustfarm"]["address"])
  var shrines = new web3.eth.Contract(nfts["shrines"]["abi"], nfts["shrines"]["address"])
  var asr = new web3.eth.Contract(nfts["AlphaShrineRouter"]["abi"], nfts["AlphaShrineRouter"]["address"])
  var crystal_staking = new web3.eth.Contract(nfts["crystalStaking"]["abi"], nfts["crystalStaking"]["address"])

  // initialize farm contracts
  var farm__burn = new web3.eth.Contract(farms["burn"]["abi"], farms["burn"]["address"])
  var farm__gate = new web3.eth.Contract(farms["gate"]["abi"], farms["gate"]["address"])
  var farm__degenesis = new web3.eth.Contract(farms["degenesis"]["abi"], farms["degenesis"]["address"])
  
  var fam = new web3.eth.Contract(nfts["fam"]["abi"], nfts["fam"]["address"])

  const letItRip = () => {
    console.log("let it rip")
  }

const getTransactionReceipt = (hash, callback= ()=>{}) => {
  console.log(hash)
  window.ethereum.request({
    method: "eth_getTransactionReceipt",
    params: [hash]
  }).then((res)=>{
    if (res == null) {
      getTransactionReceipt(hash, callback)
    }
    callback(res)
  }).catch((err)=>{
    console.log(err)
  })
}


const estimateGas = (contract, data, saveError, callback = ()=>{}) => {
   window.ethereum.request(
        {
          method: "eth_estimateGas",
          params: [
            {
              from: window.ethereum.selectedAddress,
              to: contract,     
              data: data,
            },
          ],
        }
      ).then((gasAmount)=>{
        callback()
      }).catch((err)=>{

        saveError(err.data.message)
        alert(err.data.message)
      })
}

const sendRequest = (contract, data, callback = ()=>{}) => {
  setIsPending(true)

  window.ethereum.request({
    method: "eth_sendTransaction",
    params: [
      {
        from: window.ethereum.selectedAddress,
        to: contract,
        value: 0,
        data: data,
      },
    ],}).then((hash)=>{
      getTransactionReceipt(hash,(receipt)=>{
        if (receipt != null) {
          setIsPending(false)
          callback()
        }
      })
    }).catch((err)=>{
      setIsPending(false)
    })
}


// -- Generic 1155 ----
const balanceOf = (erc1155, id, setState) => {
  console.log("Fetching item balance")
  erc1155.methods.balanceOf(
    window.ethereum.selectedAddress,
    id
    ).call({from: window.ethereum.selectedAddress})
     .then((res)=>{
      setState(res)
     }).catch((error)=>{
      console.log(error)
     })
}

const balanceOfBatch = (erc1155, ids, setState) => {
  console.log("Fetching item balances")
  erc1155.methods.balanceOfBatch(
    Array(ids.length).fill(window.ethereum.selectedAddress),
    ids
    ).call({from: window.ethereum.selectedAddress})
     .then((res)=>{
      setState(res)
     }).catch((error)=>{
      console.log(error)
     })
}

const bal20 = (token, callback = ()=>{}) => {
  token.methods.balanceOf(window.ethereum.selectedAddress)
    .call({from: window.ethereum.selectedAddress})
    .then((balance) => {
      callback(balance)
    })
}

const checkFamBalance = (callback = ()=>{}) => {
    bal20(fam,(balance)=>{
      setBalFam(balance)
      callback(balance)
    })
  }
const checkCandleBalance = (callback = ()=>{}) => {
    bal20(candle,(balance)=>{
      setBalCandle(balance)
      callback(balance)
    })
  }
const checkCultBalance = (callback = ()=>{}) => {
    bal20(cult,(balance)=>{
      setBalCult(balance)
      callback(balance)
    })
  }
const checkXcultBalance = (callback = ()=>{}) => {
    bal20(xcult,(balance)=>{
      setBalXCult(balance)
      callback(balance)
    })
  }
const checkTokenBalances= () => {
  checkFamBalance(
    checkCandleBalance(
      checkCultBalance(
        checkXcultBalance()
        )
      )
    )
}
  // -- Dash Item Components ----

  const DashItem = (props)=>(
    <div className="dashboard__item" onClick={props.onClick}>
      <img src={props.src}/>
      <div className="dashboard__balance">{Number(props.bal)}</div>
    </div>
    )


  // -- balance states erc20 ----
  const [balCandle, setBalCandle] = React.useState(0)
  const [balCult, setBalCult] = React.useState(0)
  const [balXCult, setBalXCult] = React.useState(0)
  const [balFam, setBalFam] = React.useState(0)

  // -- balance states erc1155 ----
  const [balResources, setBalResources] = React.useState([0,0,0])
  const [balCrystals, setBalCrystals] = React.useState([0,0])
  const [balShrineCrystals, setBalShrineCrystals] = React.useState(0)

  // -- balance requests erc1155 ----
  const requestResources = () => {
    balanceOfBatch(resources,[1,2,3],setBalResources)
  }
  const requestCrystals = () => {
    balanceOfBatch(crystals,[1,11],setBalCrystals)
    balanceOf(shrine_crystals,101,setBalShrineCrystals)
  }


  // -- Mining Resources ----
  const [isMineShowing__Karma, setIsMineShowing__Karma] = React.useState(false)
  const [isMineShowing__Dust, setIsMineShowing__Dust] = React.useState(false)
  const [isMineShowing__Rock, setIsMineShowing__Rock] = React.useState(false)

  const mine = (index) => {
    return () => {
      if (index == 0) {
        setIsMineShowing__Karma(true)
        checkStatus()
      } else if (index == 1) {
        setIsMineShowing__Dust(true)
        checkStatusFD()
        checkFamBalance()
      } else if (index == 2) {
        setIsMineShowing__Rock(true)
        checkStatus()
      } else {
        alert("you are attempting to mine an invalid index")
      }
    }
    
  }

  const closeMine__Karma = () => {
    setIsMineShowing__Karma(false)
  }
  const closeMine__Dust = () => {
    setIsMineShowing__Dust(false)
  }
  const closeMine__Rock = () => {
    setIsMineShowing__Rock(false)
  }

  const MineModal = (props) => (
    <div className={"modal modal--" + props.name.replace(" ","-") + " modal-status--"+ props.status + " modal-statusFD--" + props.statusFD +" screen-showing--" + props.isShowing + " fambal--" + props.fambal}>
      <div className="close-modal" onClick={props.closeScreen}>
        <div>x</div>
      </div>
      <div className={props.name.replace(" ","-")}>
        <div className="mining__name">{props.name}</div>
        <div className="mining__bal">Balance: {Number(props.bal)}</div>
        <div className="mining__img"><img src={props.img}/></div>
        <div className="mining__stats">
          <div className="time">Mining Time: {props.time}</div>
          <div className="delay">Mining Delay: {props.delay}</div>
          <div className="weights">Mining Weights: {props.weights}</div>
          <div className="maxes">Mining Maxes: {props.maxes}</div>
          <div className="note">{props.note}</div>
          <div className="fdf-bal">Supply remaining: {props.fdfbal}</div>
          <div className="status-msg status--mining">You are finished mining. Now you must rest.</div>
          <div className="status-msg status--ready">You are ready to mine.</div>
          <div className="status-msg status--resting">You are resting.</div>
          <div className="status-msg status--fam">You need at least 1 Familiar to Mine</div>
        </div>
        <button className="mining__btn btn--mine" onClick={props.mine}>Mine</button>
        <button className="mining__btn btn--rest" onClick={props.rest}>Rest</button>
        <button className="mining__btn btn--refresh" onClick={props.refresh}>Refresh</button>
      </div>
    </div>



    )


  // -- Forging Resources ----
  const [isForgeShowing__Karma, setIsForgeShowing__Karma] = React.useState(false)
  const [isForgeShowing__Fam, setIsForgeShowing__Fam] = React.useState(false)
  const [isForgeShowing__Chalk, setIsForgeShowing__Chalk] = React.useState(false)
  const forge = (index) => {
   return () => {
      if (index == 0) {
        requestResources()
        requestCrystals()
        setIsForgeShowing__Karma(true)
      } else if (index == 1) {
        requestResources()
        requestCrystals()
        getShrineName()
        getShrineFee()
        setIsForgeShowing__Fam(true)

      } else if (index == 2) {
        requestResources()
        requestCrystals()
        setIsForgeShowing__Chalk(true)
      } else {
        alert("you are attempting to forge an invalid index")
      }
    }
    
  }

  const closeForge__Karma = () => {
    setIsForgeShowing__Karma(false)
  }
  const closeForge__Fam = () => {
    setIsForgeShowing__Fam(false)
  }
  const closeForge__Chalk = () => {
    setIsForgeShowing__Chalk(false)
  }

  const ForgeModal = (props) => (
    <div className={"modal modal--forge modal--" + props.name.replace(" ","-") + " screen-showing--" + props.isShowing}>
      <div className="close-modal" onClick={props.closeScreen}>
        <div>x</div>
      </div>
      <div className={props.name.replace(" ","-")}>
        <div className="mining__name">{props.name}</div>
        <div className="mining__bal">Balance: {Number(props.bal)}</div>
        <div className="mining__img"><img src={props.img}/></div>
        <div className="mining__stats">
          <div className="resource">Resource: <strong>{props.resource}</strong></div>
          <div className="rate">Conversion Rate: <strong>{props.rate}</strong></div>
          <div className="rate">Requires Shrine: <strong>{props.shrine}</strong></div>
          <div className="balres">{props.resource} Balance: <strong>{Number(props.resbal)}</strong></div>
          <div className="max">Your Max Craft Amount: <strong>{Number(props.resbal)/Number(props.rate)}</strong></div>
          <div className="active-shrine">Active Shrine: <strong>{props.activeShrineName}</strong></div>
          <div className="active-shrine-fee">Shrine Fee: <strong>{props.activeShrineFee} $CANDLE</strong></div>
          <div className="note">{props.note}</div>
        </div>
        <input ref={props.inputRef} />
        <button className="mining__btn btn--forge" onClick={props.forge}>Forge</button>  
        <button className="mining__btn btn--shrine btn--enter" onClick={props.enter}>Enter</button>
        <button className="mining__btn btn--shrine btn--leave" onClick={props.leave}>Leave</button>
      </div>
    </div>



    )


 // ------------------------------------------------------------------------------------------
  
  // -- Navigation Logic ----

  const [isNavShowing, setIsNavShowing] = React.useState(false)
  React.useEffect(()=>{
    if (connected) {
      setIsNavShowing(true)
    }
  },[connected])

  const [isDashboardShowing, setIsDashboardShowing] = React.useState(false)
  const [isFarmShowing, setIsFarmShowing] = React.useState(false)
  const [isShrinesShowing, setIsShrinesShowing] = React.useState(false)
  const [isStakingShowing, setIsStakingShowing] = React.useState(false)
  const [isItemShopShowing, setIsItemShopShowing] = React.useState(false)


  const openDash = () => {
    setIsDashboardShowing(true)
    requestResources()
    requestCrystals()
    checkTokenBalances()
  }

  const closeDash = () => {
    setIsDashboardShowing(false)
  }

  const openStaking = () => {
    setIsStakingShowing(true)
    requestCrystals()
    updateAmtStaked()
    updateAmtStaked_k()
  }

  const closeStaking = () => {
    setIsStakingShowing(false)
  }

  const openShrines = () => {
    setIsShrinesShowing(true)
  }
  const closeShrines = () => {
    setIsShrinesShowing(false)
  }

  const openFarms = () => {
    setIsFarmShowing(true)
  }
  const closeFarms = () => {
    setIsFarmShowing(false)
  }

  const openItemShop = () => {
    setIsItemShopShowing(true)
  }
  const closeItemShop = () => {
    setIsItemShopShowing(false)
  }


  const [isShrineListShowing, setIsShrineListShowing] = React.useState(false)
  const [isShrinePurchaseShowing, setIsShrinePurchaseShowing] = React.useState(false)
  const [isShrineManageShowing, setIsShrineManageShowing] = React.useState(false)

  const toggleShrineScreen = (i) => {
    if ( i == 0) {
      return () => {
        if (isShrineListShowing) {
          setIsShrineListShowing(false)
        } else {
          setIsShrineListShowing(true)
        }
      }
    }

    if ( i == 1) {
      return () => {
        if (isShrinePurchaseShowing) {
          setIsShrinePurchaseShowing(false)
        } else {
          setIsShrinePurchaseShowing(true)
        }
      }
    }

    if ( i == 2) {
      return () => {
        if (isShrineManageShowing) {
          setIsShrineManageShowing(false)
        } else {
          setIsShrineManageShowing(true)
        }
      }
    }
  }

  const [isCsOpen_fam, setIsCsOpen_fam] = React.useState(false)
  const [isCsOpen_karma, setIsCsOpen_karma] = React.useState(false)

  const openCs = (poolID) => {
    if (poolID == 0) {
      return () => {
        setIsCsOpen_fam(true)
      }
    }

    if (poolID == 1) {
      return () => {
        setIsCsOpen_karma(true)
      }
    }

  }

  const closeCs = (poolID) => {
    if (poolID == 0) {
      return () => {
        setIsCsOpen_fam(false)
      }
    }

    if (poolID == 1) {
      return () => {
        setIsCsOpen_karma(false)
      }
    }

  }

  // ------------------------------------------------------------------------------------
  // -- Status Checks ------------------------------------------------------

  const getLastMinedResource = (callback = ()=>{}) =>{
    resources.methods.lastMinedResource(window.ethereum.selectedAddress)
      .call({from: window.ethereum.selectedAddress})
      .then((res)=>{
        callback(res)
      }).catch((err)=>{
        console.log(err)
      })
  }

  const getStartMiningBlock = (callback = ()=>{}) => {
    resources.methods.startMiningBlock(window.ethereum.selectedAddress)
      .call({from: window.ethereum.selectedAddress})
      .then((res)=>{
        callback(res)
      }).catch((err)=>{
        console.log(err)
      })
  }

  const getStopMiningBlock = (callback = () => {}) => {
    resources.methods.stopMiningBlock(window.ethereum.selectedAddress)
      .call({from: window.ethereum.selectedAddress})
      .then((res)=>{
        callback(res)
      }).catch((err)=>{
        console.log(err)
      })
  }

  const getCurrentBlock = (callback = () => {}) => {
    web3.eth.getBlockNumber()
    .then((res)=>{
      callback(res)
    }).catch((err)=>{
      console.log(err)
    })
  }

  const getStartMiningBlockFD = (callback = () => {}) => {
    fdf.methods.startMiningBlock(window.ethereum.selectedAddress)
      .call({from: window.ethereum.selectedAddress})
      .then((res)=>{
        callback(res)
      }).catch((err)=>{
        console.log(err)
      })
  }

  const getStopMiningBlockFD = (callback = () => {}) => {
    fdf.methods.stopMiningBlock(window.ethereum.selectedAddress)
      .call({from: window.ethereum.selectedAddress})
      .then((res)=>{
        callback(res)
      }).catch((err)=>{
        console.log(err)
      })
  }

  const [status, setStatus] = React.useState("none")
  const [statusFD, setStatusFD] = React.useState("none")
  const [lastMinedResource, setLastMinedResource] = React.useState(0)
  const checkStatus = () => {
    console.log("Checking status...")
    
    getStartMiningBlock((startBlock) =>{

      if (Number(startBlock) > 0) {
        console.log("startblock > 0",startBlock)
        // user is mining
        setStatus("mining")
        getLastMinedResource(setLastMinedResource)
      } else {

        // user is not mining
        getStopMiningBlock((stopBlock)=>{
          if (Number(stopBlock) > 0) {
            console.log("stopblock > 0",stopBlock)
            // user is resting
            getLastMinedResource((resourceID) => {
              setLastMinedResource(Number(resourceID))
              let delay = MINING_DELAYS[Number(resourceID)]

              getCurrentBlock((blockNumber)=>{
                if (delay + Number(stopBlock) <= Number(blockNumber)) {
                  console.log("user is done resting")
                  // user is done resting
                  setStatus("ready")
                } else {
                  console.log("user is resting")
                  // user is resting
                  setStatus("resting")
                }
              })

            })

          } else {
            // user is neither mining nor resting
            setStatus("newUser")
          }
        })
      }
    })
  }
  

  const checkStatusFD = () => {
     console.log("Checking status FD...")
     getStartMiningBlockFD((startBlock) =>{

      if (Number(startBlock) > 0) {
        console.log("startblock > 0",startBlock)
        // user is mining
        setStatusFD("mining")
      } else {
        // user is not mining
        getStopMiningBlockFD((stopBlock)=>{
          if (Number(stopBlock) > 0) {
            console.log("stopblock > 0",stopBlock)
            // user is resting
            let delay = MINING_DELAYS[2]

            getCurrentBlock((blockNumber)=>{
              if (delay + Number(stopBlock) <= Number(blockNumber)) {
                console.log("user is done resting")
                // user is done resting
                setStatusFD("ready")
              } else {
                console.log("user is resting")
                // user is resting
                setStatusFD("resting")
              }
            })
          } else {
            // user is neither mining nor resting
            setStatusFD("newUser")
          }
        })
      }
    })

    checkFDFbal()
  }

  const [fdfBal, setFdfbal] = React.useState(0)
  const checkFDFbal = () => {
    console.log("Checking FDF balance")
    resources.methods.balanceOf(
      nfts["famdustfarm"]["address"],
      2
    ).call({from: window.ethereum.selectedAddress})
     .then((res)=>{
      console.log("Checked FDF balance")
      setFdfbal(Number(res))
     }).catch((error)=>{
      console.log(error)
     })
  }

  // ------------------------------------------------------------------------------------------
  // -- Mining and Rest functions for normal resources
  const startMining = (id) => {
    return () => {
      let data = resources.methods.mine(id).encodeABI()
      setIsPending(true)
      setPendingText("Mining " + RES_NAMES[id])
      sendRequest(nfts["resources"]["address"], data, ()=>{
        setIsPending(false)
        checkStatus()
      })
        
    }
  }

  const rest = () => {
    setIsPending(true)
    setPendingText("Resting, this will mint your pending resource")
    let data = resources.methods.rest().encodeABI()
    sendRequest(nfts["resources"]["address"],data, ()=> {
      setIsPending(false)
      checkStatus()
      requestResources()
    })
  }

  // ------------------------------------------------------------------------------------------
  // -- Mining and Rest functions for Familiar Dust 

  const startMiningFD = () => {
    console.log("Begin Mining")
    checkFamBalance((balance)=>{

      let bal = web3.utils.fromWei(balance, "ether")
      console.log("user has ",bal)
      if (bal >= 1) {
        let data = fdf.methods.mine().encodeABI()
        setIsPending(true)
        setPendingText("Mining Familiar Dust")
        sendRequest(nfts["famdustfarm"]["address"],data,()=>{
          setIsPending(false)
          checkStatusFD()
        })
      } else {
        alert("You have " + bal + " familiars, you need at least 1 to mine Dust.")
      }
    })
    
  }

  const restFD = () => {
    let data = fdf.methods.rest().encodeABI()
    setIsPending(true)
    setPendingText("Resting, this will mint your Familiar Dust")
    sendRequest(nfts["famdustfarm"]["address"],data,()=>{
      setIsPending(false)
      checkStatusFD()
      requestResources()
    })  
  }


  // -------------------------------------------------------------------
  // -- Forging Crystals ----------------------------------

  const crystalRef__karma = React.createRef()
  const crystalRef__chalk = React.createRef()

  const approve4all = (callback = () => {}) => {
    resources.methods.isApprovedForAll(window.ethereum.selectedAddress, nfts["crystals"]["address"])
      .call({from: window.ethereum.selectedAddress})
      .then((isApproved)=>{
        if (isApproved) {
          callback(isApproved)
        } else {
          let data = resources.methods.setApprovalForAll(nfts["crystals"]["address"], true).encodeABI()
          setPendingText("Approving the spending of your resources")
          sendRequest(nfts["resources"]["address"],data,callback)
        }
      })
  }

  const forgeTransaction = (id, callback = ()=>{}) => {
    let amt = (id == 1) ? crystalRef__karma.current.value : crystalRef__chalk.current.value
    let name = (id == 1) ? "Karma Crystal" : "Ritual Chalk"
    let data = crystals.methods.forge(id, amt).encodeABI()
    setIsPending(true)
    setPendingText("Forging " + amt + " " + name)
    sendRequest(nfts["crystals"]["address"], data, callback)
  }

  const startForging = (id) => {
    return () => {
      approve4all((res)=>{
        if (typeof(res) == "boolean") {
          if (res) {
            // forge 
            forgeTransaction(id, () => {
                setIsPending(false)
                requestResources()
                requestCrystals()
              })
          }
        } else {
          forgeTransaction(id, () => {
                setIsPending(false)
                requestResources()
                requestCrystals()
              })
        }
      })
    }
  }


  const [shrineError, setShrineError] = React.useState("")
  const startForgingShrine = () => {
    checkShrineConditions(
      () => {

        let data = asr.methods.enter(activeShrine + 1,101).encodeABI()
        estimateGas(nfts["AlphaShrineRouter"]["address"], data, setShrineError,
          () =>{
            setPendingText("Entering " + activeShrineName)
            sendRequest(nfts["AlphaShrineRouter"]["address"], data, ()=>{
              requestResources()
              balanceOf(shrine_crystals,101,setBalShrineCrystals)
            })
          }
          )
        
      }
      )
  }
  const finishForgingShrine = () => {
    let data = asr.methods.leave(activeShrine + 1).encodeABI()
    estimateGas(nfts["AlphaShrineRouter"]["address"], data, setShrineError,
      () => {
        setPendingText("Leaving " + activeShrineName) 
        sendRequest(nfts["AlphaShrineRouter"]["address"], data, () => {
          balanceOf(shrine_crystals,101,setBalShrineCrystals)
        })
      }
      )
  }

 // ----------------------------------------------------------------------------------------------------
 // -- Pools --

  const [farm_gate_UserInfo_0, setFarm_gate_UserInfo_0] = React.useState({})
  const [farm_gate_PendCand_0, setFarm_gate_PendCand_0] = React.useState(0)
  const [farm_gate_UserInfo_1, setFarm_gate_UserInfo_1] = React.useState({})
  const [farm_gate_PendCand_1, setFarm_gate_PendCand_1] = React.useState(0)
  const [farm_gate_UserInfo_2, setFarm_gate_UserInfo_2] = React.useState({})
  const [farm_gate_PendCand_2, setFarm_gate_PendCand_2] = React.useState(0)

  const [farm_degenesis_UserInfo_0, setFarm_degenesis_UserInfo_0] = React.useState({})
  const [farm_degenesis_PendCand_0, setFarm_degenesis_PendCand_0] = React.useState(0)
  const [farm_degenesis_UserInfo_1, setFarm_degenesis_UserInfo_1] = React.useState({})
  const [farm_degenesis_PendCand_1, setFarm_degenesis_PendCand_1] = React.useState(0)
  const [farm_degenesis_UserInfo_2, setFarm_degenesis_UserInfo_2] = React.useState({})
  const [farm_degenesis_PendCand_2, setFarm_degenesis_PendCand_2] = React.useState(0)

  const [farm_burn_UserInfo_0, setFarm_burn_UserInfo_0] = React.useState({})
  const [farm_burn_PendCand_0, setFarm_burn_PendCand_0] = React.useState(0)
  const [farm_burn_UserInfo_1, setFarm_burn_UserInfo_1] = React.useState({})
  const [farm_burn_PendCand_1, setFarm_burn_PendCand_1] = React.useState(0)
  const [farm_burn_UserInfo_2, setFarm_burn_UserInfo_2] = React.useState({})
  const [farm_burn_PendCand_2, setFarm_burn_PendCand_2] = React.useState(0)
  const [farm_burn_UserInfo_3, setFarm_burn_UserInfo_3] = React.useState({})
  const [farm_burn_PendCand_3, setFarm_burn_PendCand_3] = React.useState(0)

  const getInfo = (farmContract,poolID,setUserInfo,setPendingCandle) => {
      getUserInfo(farmContract,poolID,(info)=>{
        setUserInfo(info)
        getPendingCandle(farmContract,poolID,(pc)=>{
          setPendingCandle(pc)
        })
      })
  }
  
  const nm = (upID) => {
    let p = upID.substring(0,1)
      
    let name
    if (p == "g") {
      name = "gate"
    }
    if (p == "d") {
      name = "degenesis"
    }
    if (p == "b") {
      name = "burn"
    }
    return name
  }

  const getPoolInfo = (upID) => {
    let p = upID.substring(0,1)
      let i = upID.substring(1,2)
      
      let name = nm(upID)
      
      
      let x = "getInfo(farm__"+name+","+i+",setFarm_"+name+"_UserInfo_"+i+",setFarm_"+name+"_PendCand_"+i+")"
  
      eval(x)
  }

  const gtr_update = (upID) => {
    return ()=>{
      setIsPending(false)
      getPoolInfo(upID)
    }
  }
const deposit = (farmContract,farmContractAddress, poolID, amount, callback=()=>{}, handleError=()=>{}) => {
  let amt = web3.utils.fromWei(amount, "ether")
  if (amt > 0 ) setPendingText("Depositing " + amt + nameByID(poolID) + " to gated pool " + poolID)
    let data = farmContract.methods.deposit(poolID,amount).encodeABI()
    sendRequest(farmContractAddress, data, callback)
  
}

const tokenContract = (tokenName) => {
  return new web3.eth.Contract(tokens[tokenName]["abi"], tokens[tokenName]["address"])
}
const tokenAddress = (tokenName) => {
  return tokens[tokenName]["address"]
}

const nameByUpID = (upID) => {
  let name 
  name = (upID == "g0") ? "cult" : ((upID == "g1") ? "xcult" : "candle")
  return name
}

const nameByID = (ID) => {
  let name 
  name = (ID == 0) ? "cult" : ((ID == 1) ? "xcult" : "candle")
  return name
}


const depositControllerWrapper = (farmContract,farmContractAddress, poolID, amount, callback=()=>{}, handleError=()=>{}) => {
  setPendingText("Checking Item Balances")
  if (Number(poolID) == 0) {

    balanceOfBatch(items,[11,12,13],(balances) => {
      let sum = Number(balances[0]) + Number(balances[1]) + Number(balances[2])
      if (sum == 0) {
        alert("You need a briefcase to stake in this pool. Visit The Item Shop at the thedevilslounge.com")
        setIsPending(false)
      } else {
        depositController(farmContract,farmContractAddress, poolID, amount, callback, handleError)
      }
    })
  } else if (Number(poolID == 1)) {
    balanceOfBatch(items,[1,2],(balances) => {
      let sum = Number(balances[0]) + Number(balances[1])
      if (sum == 0) {
        alert("You need an apple to stake in this pool. Visit The Item Shop at the thedevilslounge.com")
        setIsPending(false)
      } else {
        depositController(farmContract,farmContractAddress, poolID, amount, callback, handleError)
      }
    })
  } else {
    balanceOfBatch(items,[1,2,11,12,13],(balances) => {
      let sum = Number(balances[0]) + Number(balances[1]) + Number(balances[2]) + Number(balances[3]) + Number(balances[4])
      if (sum == 0) {
        alert("You need an apple or a briefcase to stake in this pool. Visit The Item Shop at the thedevilslounge.com")
        setIsPending(false)
      } else {
        depositController(farmContract,farmContractAddress, poolID, amount, callback, handleError)
      }
    })
  }
}
const depositController = (farmContract,farmContractAddress, poolID, amount, callback=()=>{}, handleError=()=>{}) => {
  


  let token = tokenContract(nameByID(poolID))
  let amt = web3.utils.fromWei(amount, "ether")
  if (amt > 0) {
    // we need to check the user's balance
    setPendingText("Checking User Balance")
    token.methods.balanceOf(window.ethereum.selectedAddress)
      .call({from: window.ethereum.selectedAddress})
      .then((balance) => {
        let bal = web3.utils.fromWei(balance, "ether")
        if (bal >= amt) {
          // if the user's balance is greater than the amount
          // -- then we need to check the user's allowance
          token.methods.allowance(window.ethereum.selectedAddress,farmContractAddress)
            .call({from: window.ethereum.selectedAddress})
            .then((allowance) => {
              let alw = web3.utils.fromWei(allowance, "ether")
              if (alw >= amt) {
                deposit(farmContract,farmContractAddress,poolID,amount,callback,handleError)
              } else {
                let data = token.methods.approve(farmContractAddress,amount).encodeABI()
                setPendingText("Approving " + amt + " " + nameByID(poolID))
                sendRequest(tokens[nameByID(poolID)]["address"],data, ()=>{
                  deposit(farmContract,farmContractAddress,poolID,amount,callback,handleError)
                })
              }
            })
        } else {
          alert("You only have " + bal + " "+ nameByID(poolID))
          setIsPending(false)
        }
      })
  } else { 
    deposit(farmContract,farmContractAddress,poolID,amount,callback,handleError)
  }
}

const withdraw = (farmContract,farmContractAddress, poolID, amount, callback=()=>{}, handleError=()=>{}) => {
  
  if (Number(amount) == 0) {
    alert("You have nothing to withdraw")
    setIsPending(false)
  } else {
    let data = farmContract.methods.withdraw(poolID,amount).encodeABI()
    sendRequest(farmContractAddress, data, callback)
  }
  
}

  const claim = (upID) => {
    return () => {
      setIsPending(true)
      let p = upID.substring(0,1)
      let i = upID.substring(1,2)
      let name = nm(upID)
      setPendingText("claiming rewards for " + name + " pool " + i)
      let x = "deposit(farm__"+name+",farms."+name+".address,"+i+",0,gtr_update('" + upID + "'))"
      eval(x)

    }
  }

  const ui = (upID) => {
    let name = nm(upID)
    let i = upID.substring(1,2)
    let x = "farm_" + name + "_UserInfo_" + i
    return x 
  }


  const withdrawAll = (upID) => {
    return () => {
      setIsPending(true)
      let amount = eval(ui(upID) + ".amount")
      let name = nm(upID)
      let i = upID.substring(1,2)
      setPendingText("Withdrawing " + fs(amount) + " from " + name + " pool " + i)
      
      let x = "withdraw(farm__"+name+",farms."+name+".address,"+i+","+amount+",gtr_update('" + upID + "'))"
      eval(x)
    }
    
  }

  const g0inputRef = React.createRef()
  const g1inputRef = React.createRef()
  const g2inputRef = React.createRef()
  const stake = (upID) => {
    return () => {
      setIsPending(true)
      let amount = eval(upID + "inputRef.current.value")
      amount = Number(amount)
      let amt = web3.utils.toWei(amount,"ether")

 
      let name = nm(upID)
      let i = upID.substring(1,2)
      
      
      let x = "depositControllerWrapper(farm__"+name+",farms."+name+".address,"+i+","+amt+",gtr_update('" + upID + "'))"
      eval(x)
    }
  }

  

  const [activePool, setActivePool] = React.useState("")
  const showPool = (upID) => {
    return () => {
      setActivePool(upID)
      getPoolInfo(upID)
    }
  }

  const closePool = () => {

      setActivePool("")
    
  }

  const [isInputShowing, setIsInputShowing] = React.useState(false)

  const [activeShrine, setActiveShrine] = React.useState(0)
  const [activeShrineName, setActiveShrineName] = React.useState("")
  const [activeShrineFee, setActiveShrineFee] = React.useState("0")


  const approveForShrinePurchase = (callback = () => {}) => {
    crystals.methods.isApprovedForAll(window.ethereum.selectedAddress, nfts["shrines"]["address"])
      .call({from: window.ethereum.selectedAddress})
      .then((res)=>{
        if (res) {
          callback(res)
        } else {
          let data = crystals.methods.setApprovalForAll(nfts["shrines"]["address"], true).encodeABI()
          setPendingText("Approving the spending of your crystals")
          sendRequest(nfts["crystals"]["address"], data, callback)
        }
      })
    
  }

  const approveCandleForShrinePurchase = (callback = ()=>{}) => {
    candle.methods.balanceOf(window.ethereum.selectedAddress)
      .call({from: window.ethereum.selectedAddress})
      .then((balance) => {
        let bal = web3.utils.fromWei(balance, "ether")
        if (bal >= 10000) {
          // if the user's balance is greater than the amount
          // -- then we need to check the user's allowance
          candle.methods.allowance(window.ethereum.selectedAddress,nfts["shrines"]["address"])
            .call({from: window.ethereum.selectedAddress})
            .then((allowance) => {
              let alw = web3.utils.fromWei(allowance, "ether")
              if (alw >= 10000) {
                callback()
              } else {
                let data = candle.methods.approve(nfts["shrines"]["address"],web3.utils.toWei(10000,"ether")).encodeABI()
                setPendingText("Approving 10,000 $CANDLE")
                sendRequest(tokens["candle"]["address"],data,callback)
              }
            })
        } else {
          alert("You do not have enough $CANDLE")
        }
        
      })
  }

  
  const purchaseShrine = () => {
    approveForShrinePurchase(
      approveCandleForShrinePurchase(() => {
        let data = shrines.methods.purchase().encodeABI()
        setPendingText("Purchasing a shrine.")
        sendRequest(nfts["shrines"]["address"], data)
      })) 
  }

  const [isOwnedShrineLoaded, setIsOwnedShrineLoaded] = React.useState(false)
  const [loadedShrineName, setLoadedShrineName] = React.useState(false)
  const [loadedShrineNumber, setLoadedShrineNumber] = React.useState(false)
  const shrineNameRef = React.createRef()
  const shrineFeeRef = React.createRef()

  const shrineOwners = [
    "0x8DE3c3891268502F77DB7E876d727257DEc0F852",
    "0x36d481b3c6ceca782b1FE72a80D704dA06E6c063",
    "0x5bFaad4A04Ab0Fab6d206c9ea1144da886d31f9a",
    "0x5d02c857E98465f5b3a957B1f43569C4dAe58cA0",
    "0xA0035d1B65f408D605C2754b9aCD0E3bA4013202",
    "0xe5845761e7773976055F2559ca54be41F09d9E88",
    "0xd6B598C0D187c5d190f12f1034FBa11C300e06fA",
    "0xEE13Ae5Caf40f5757Ed890be6330788779984BfA",
    "0x6Fb966a32bE4C0d10A0329BDB1F01Dd89Ad264c2",
    "0xf09738069C21d1b874eF2d8F51812f5600304660",
    "0x656A41EeBec46A6f3709783c8C93c2E522d2AfEB"
  ];

  const detectOwnedShrine = () => {
    console.log("detecting Owned Shrine")
    shrineOwners.forEach((owner,index) => {
      console.log(owner,window.ethereum.selectedAddress)
      if (owner.toLowerCase() == window.ethereum.selectedAddress.toLowerCase()) {
        console.log("success")
        setLoadedShrineNumber(index + 1)
        setIsOwnedShrineLoaded(true)

        shrines.methods.getShrineName(index + 1)
          .call({from: window.ethereum.selectedAddress})
          .then((name)=>{
            setLoadedShrineName(name)

          })
      }
    })
  }

  const updateShrineName = () => {
    let data = shrines.methods.setShrineName(loadedShrineNumber, shrineNameRef.current.value).encodeABI()
    setPendingText("Updating name of shrine #" + loadedShrineNumber + " to " + shrineNameRef.current.value)
    sendRequest(nfts["shrines"]["address"], data)
  } 

  const updateShrineFee = () => {
    let data = shrines.methods.setShrineFee(loadedShrineNumber, web3.utils.toWei(shrineFeeRef.current.value, "ether")).encodeABI()
    setPendingText("Updating fee of shrine #" + loadedShrineNumber + " to " + shrineFeeRef.current.value)
    sendRequest(nfts["shrines"]["address"], data)
  }

  const getShrineName = () => {
    shrines.methods.getShrineName(activeShrine + 1)
      .call({from: window.ethereum.selectedAddress})
      .then((name)=>{
        setActiveShrineName(name)
      })
  }
  const getShrineFee = () => {
    shrines.methods.getShrineFee(activeShrine + 1)
      .call({from: window.ethereum.selectedAddress})
      .then((fee)=>{
        setActiveShrineFee(web3.utils.fromWei(fee,"ether"))
      })
  }

  const checkAllowanceThenApprove = (callback = ()=>{}) => {
     candle.methods.allowance(window.ethereum.selectedAddress,nfts["AlphaShrineRouter"]["address"])
        .call({from: window.ethereum.selectedAddress})
        .then((allowance) => {
          let alw = web3.utils.fromWei(allowance, "ether")
          if (alw >= activeShrineFee) {
            callback()
          } else {
            let data = candle.methods.approve(nfts["AlphaShrineRouter"]["address"],web3.utils.toWei(activeShrineFee,"ether")).encodeABI()
            setPendingText("Approving "+activeShrineFee+" $CANDLE")
            sendRequest(tokens["candle"]["address"],data,callback)
          }
        })
  }

  const checkShrineConditions = (callback = ()=> {}) => {
    if (balResources[1] >= 32) {
      candle.methods.balanceOf(window.ethereum.selectedAddress)
        .call({from: window.ethereum.selectedAddress})
        .then((balance) => {
          let bal = web3.utils.fromWei(balance, "ether")
          if (bal >= activeShrineFee) {
            resources.methods.isApprovedForAll(window.ethereum.selectedAddress, nfts["AlphaShrineRouter"]["address"])
              .call({from: window.ethereum.selectedAddress})
              .then((isApproved)=>{
                if (isApproved) {
                  checkAllowanceThenApprove(callback)
                } else {
                  let data = resources.methods.setApprovalForAll(nfts["AlphaShrineRouter"]["address"], true).encodeABI()
                  setPendingText("Approving the spending of your resources")
                  sendRequest(nfts["AlphaShrineRouter"]["address"],data,()=>{
                    checkAllowanceThenApprove(callback)
                  })
                }
              })

          } else {
            alert("You need more $CANDLE")
          }
        })
    } else {
      alert("You need more Familiar Dust")
    }
  }

  // ----------------------------------------------------------------------------------------------------
  // ------ Crystal Staking ---------------------------------




  const stakeRef = React.createRef()
  const unstakeRef = React.createRef()

  const stakeCrystals = () => {
    setPendingText("Staking " + stakeRef.current.value + " Familiar Crystals")
    let data = crystal_staking.methods.deposit(1,stakeRef.current.value).encodeABI()
    sendRequest(nfts["crystalStaking"]["address"], data, ()=>{
      requestCrystals()
      updateAmtStaked()
    })
  }

  const unstakeCrystals = () => {
    setPendingText("Unstaking " + unstakeRef.current.value + " Familiar Crystals")
    let data = crystal_staking.methods.withdraw(1,unstakeRef.current.value).encodeABI()
    sendRequest(nfts["crystalStaking"]["address"], data, ()=>{
       requestCrystals()
      updateAmtStaked()
    })
  }

  const claimRewards = () => {
    setPendingText("Claiming rewards")
    let data = crystal_staking.methods.harvest(1).encodeABI()
    estimateGas(nfts["crystalStaking"]["address"], data,()=>{}, () => {
      sendRequest(nfts["crystalStaking"]["address"], data, ()=>{

      })
    })
    
  }

const approve4allCS = () => {
  let data = shrine_crystals.methods.setApprovalForAll(nfts["crystalStaking"]["address"], true).encodeABI()
  sendRequest(nfts["shrineCrystals"]["address"], data, ()=>{

  })
}

const [userAmountStaked, setUserAmountStaked] = React.useState(0)

const updateAmtStaked = () => {
  crystal_staking.methods.getUserInfoByAddressAndPool(window.ethereum.selectedAddress,1)
    .call({from: window.ethereum.selectedAddress})
    .then((res)=>{
      setUserAmountStaked(Number(res.amountStaked))
      
    })
}




  // ------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  const stakeRef_k = React.createRef()
  const unstakeRef_k = React.createRef()

  const stakeCrystals_k = () => {
    setPendingText("Staking " + stakeRef_k.current.value + " Karma Crystal")
    let data = crystal_staking.methods.deposit(2,stakeRef_k.current.value).encodeABI()
    setPendingText("Staking Karma Crystals")
    sendRequest(nfts["crystalStaking"]["address"], data, () => {
      requestCrystals()
      updateAmtStaked_k()
    })
  }

  const unstakeCrystals_k = () => {
     setPendingText("Unstaking " + unstakeRef_k.current.value + " Karma Crystals")
    let data = crystal_staking.methods.withdraw(2,unstakeRef_k.current.value).encodeABI()
    sendRequest(nfts["crystalStaking"]["address"], data, () => {
      requestCrystals()
      updateAmtStaked_k()
    })
  }


  const claimRewards_k = () => {
    let data = crystal_staking.methods.harvest(2).encodeABI()
    estimateGas(nfts["crystalStaking"]["address"], data,()=>{}, () => {
      sendRequest(nfts["crystalStaking"]["address"], data, ()=>{

      })
    })
    
    
  }

  const approve4allCS_k = () => {
  let data = crystals.methods.setApprovalForAll(nfts["crystalStaking"]["address"], true).encodeABI()
  sendRequest(nfts["crystalStaking"]["address"], data, () => {

  })
}

const [userAmountStaked_k, setUserAmountStaked_k] = React.useState(0)

const updateAmtStaked_k = () => {
  crystal_staking.methods.getUserInfoByAddressAndPool(window.ethereum.selectedAddress,2)
    .call({from: window.ethereum.selectedAddress})
    .then((res)=>{
      setUserAmountStaked_k(Number(res.amountStaked))
      
    })
}

  

  // ----------------------------------------------------------------------------------------------------

  return (
    <div className="App">
      <div className="the-forge"> 
        <div className={"header header-connected--" + connected}>
          <div className="home">
            <div className="home__img"><img src={door}/></div>
            <div className="home__text">The Forge</div>
            <button 
              disabled={isDisabled} 
              onClick={connectMM} 
              className="mmbtn">
              {mmBtnText}
            </button>
          </div>
        </div>
        
        <div className={"screen screen--nav screen-showing--" + isNavShowing}>
          <div className="home">
            <div className="home__img"><img src={door}/></div>
            <div className="home__text">The Forge</div>
          <button className="nav__btn" onClick={openDash}>Dashboard</button>
          <button className="nav__btn" onClick={openStaking}>Crystal Staking</button>
          <button className="nav__btn" onClick={openShrines}>Shrines</button>
          <button className="nav__btn" onClick={openFarms}>Farms</button>
          <button className="nav__btn" onClick={openItemShop}>Item Shop</button>
          </div>
        </div>
        {
          /*
            Dashboard
          */
        }
      
        <div className={"screen screen--dashboard screen-showing--" + isDashboardShowing}>
          <div className="close-screen" onClick={closeDash}>
            <div>x</div>
          </div>
          <div className="dashboard">
            <div className="dashboard__image">
              <img src={fam1} />
            </div>

            <div className="dashboard__inventory">
              <div className="dashboard__row">
                <p className="dashboard__rowtitle">Mine Resources</p>
                <DashItem 
                  src={resource__karma} 
                  bal={balResources[0]} 
                  onClick={mine(0)} />
                <DashItem 
                  src={resource__dust} 
                  bal={balResources[1]} 
                  onClick={mine(1)} />
                <DashItem 
                  src={resource__rock} 
                  bal={balResources[2]} 
                  onClick={mine(2)} />

              </div>
              <div className="dashboard__row">
                <p className="dashboard__rowtitle">Forge Crystals and Relics</p>
                <DashItem 
                  src={crystal__karma} 
                  bal={balCrystals[0]} 
                  onClick={forge(0)} />
                <DashItem 
                  src={crystal__fam} 
                  bal={balShrineCrystals} 
                  onClick={forge(1)} />
                <DashItem 
                  src={crystal__chalk} 
                  bal={balCrystals[1]} 
                  onClick={forge(2)} />
              </div>

              <div className="dashboard__row">
                <p className="dashboard__rowtitle">Token Balances</p>
                <DashItem 
                  src={tokens["cult"]["icon"]} 
                  bal={f.format(web3.utils.fromWei(balCult, "ether"))} 
                  onClick={()=>{

                  }} />
                <DashItem 
                  src={tokens["xcult"]["icon"]} 
                  bal={f.format(web3.utils.fromWei(balXCult, "ether"))} 
                  onClick={()=>{
                    
                  }} />
                <DashItem 
                  src={tokens["candle"]["icon"]} 
                  bal={Math.round(web3.utils.fromWei(balCandle, "ether"))} 
                  onClick={()=>{
                    
                  }} />
                <DashItem 
                  src={tokenImg__fam} 
                  bal={f.format(web3.utils.fromWei(balFam, "ether"))} 
                  onClick={()=>{
                    
                  }} />
              </div>
            </div>
          </div>
        </div>

        <MineModal
          name="Karma"
          bal={balResources[0]}
          time="1 Block"
          delay="10,000 Blocks"
          weights="[1,1,...,1]"
          maxes="[1,1,...,1]"
          note="Karma is used to forge Karma Crystals"
          img={resource__karma}
          isShowing={isMineShowing__Karma}
          closeScreen={closeMine__Karma}
          status={status}
          mine={startMining(1)}
          rest={rest} 
          refresh={checkStatus}/>

        <MineModal
          name="Familiar Dust"
          bal={balResources[1]}
          time="1 Block"
          delay="1000 Blocks"
          weights="Familiars Only"
          maxes="No Maxes"
          note="Familiar Dust is used to forge Familiar Crystals"
          fambal={Math.floor(web3.utils.fromWei(balFam, "ether"))}
          img={resource__dust}
          isShowing={isMineShowing__Dust}
          closeScreen={closeMine__Dust}
          statusFD={statusFD}
          mine={startMiningFD}
          rest={restFD}
          refresh={checkStatusFD}
          fdfbal={fdfBal} />

        <MineModal
          name="Sacred Rock"
          bal={balResources[2]}
          time="1 Block"
          delay="1 Block"
          weights="[10,1,...,1]"
          maxes="[5,5,...,5]"
          note="Rock is mined in Eden in Chapter 1 of the Campaign. It is used to craft Ritual Chalk."
          img={resource__rock}
          isShowing={isMineShowing__Rock}
          closeScreen={closeMine__Rock}
          status={status}
          mine={startMining(3)}
          rest={rest}
          refresh={checkStatus}/>

          <ForgeModal
            name="Karma Crystal"
            bal={balCrystals[0]}
            resbal={balResources[0]}
            img={crystal__karma}
            isShowing={isForgeShowing__Karma}
            closeScreen={closeForge__Karma}
            resource="Karma"
            rate="32"
            shrine="No"
            note=""
            inputRef={crystalRef__karma}
            forge={startForging(1)}

          />

          <ForgeModal
            name="Familiar Crystal"
            bal={balShrineCrystals}
            resbal={balResources[1]}
            img={crystal__fam}
            isShowing={isForgeShowing__Fam}
            closeScreen={closeForge__Fam}
            resource="Familiar Dust"
            rate="32"
            shrine="Yes"
            note=""
            activeShrine={activeShrine}
            activeShrineName={activeShrineName}
            activeShrineFee={activeShrineFee}
            enter={startForgingShrine}
            leave={finishForgingShrine}
          />

          <ForgeModal
            name="Ritual Chalk"
            bal={balCrystals[1]}
            resbal={balResources[2]}
            img={crystal__chalk}
            isShowing={isForgeShowing__Chalk}
            closeScreen={closeForge__Chalk}
            resource="Rock"
            rate="4"
            shrine="No"
            note=""
            inputRef={crystalRef__chalk}
            forge={startForging(11)}
          />
          <div className={"screen screen--itemshop screen-showing--" + isItemShopShowing}>
            <div className="close-screen" onClick={closeItemShop}><div>x</div></div>
            <h1>Item Shop</h1>
            <ItemShop 
              web3={web3}
              isOpen={isItemShopShowing} />
          </div>
          <div className={"screen screen--staking screen-showing--" + isStakingShowing}>
            <div className="close-screen" onClick={closeStaking}><div>x</div></div>
            <h1>Crystal Staking</h1>
            <div className="staking-pool">
              <div className="staking">
                <div className="staking__name">Stake Familiar Crystals</div>
                <div className="staking__reward">Earn $CANDLE</div>
                <div className="staking__img"><img src={crystal__fam}/></div>
                <div className="staking__asset">
                  <p>You have {userAmountStaked} Familiar Crystals staked.</p>
                  <p>You have {Number(balShrineCrystals)} Familiar Crystals available.</p>
                  
                </div>
                <button className="open-cs" onClick={openCs(0)}>Stake</button>
              </div>
            </div>
            <div className="staking-pool">
              <div className="staking">
                <div className="staking__name">Stake Karma Crystals</div>
                <div className="staking__reward">Earn $CANDLE</div>
                <div className="staking__img"><img src={crystal__karma}/></div>
                <div className="staking__asset">
                  <p>You have {userAmountStaked_k} Karma Crystals staked.</p>
                  <p>You have {Number(balCrystals[0])} Karma Crystals available.</p>
                </div>
                <button className="open-cs" onClick={openCs(1)}>Stake</button>
              </div>
            </div>
            <div className={"modal modal--cs-fam screen-showing--" + isCsOpen_fam}>
              <h2>Stake Familiar Crystal</h2>
              <div className="reward">Earn $CANDLE</div>
              <div className="close-modal" onClick={closeCs(0)}>
                <div>x</div>
              </div>
              <div className="staking__img"><img src={crystal__fam}/></div>
              <p>You have {Number(balShrineCrystals)} Familiar Crystals available.</p>
              <div className="stake-cs"><input ref={stakeRef}/><button onClick={stakeCrystals}>Stake</button></div>
              <p>You have {userAmountStaked} Familiar Crystals staked.</p>
              <div className="unstake-cs"><input ref={unstakeRef}/><button onClick={unstakeCrystals}>Unstake</button></div>
              <button className="claim-cs" onClick={claimRewards}>Claim $CANDLE</button>
              <button className="approve-cs" onClick={approve4allCS}>Approve Shrine Crystals</button>
            </div>

            <div className={"modal modal--cs-karma screen-showing--" + isCsOpen_karma}>
              <div className="close-modal" onClick={closeCs(1)}>
                <div>x</div>
              </div>
              <h2>Stake Karma Crystal</h2>
              
              <div className="reward">Earn $CANDLE</div>
              <div className="staking__img"><img src={crystal__karma}/></div>
              <p>You have {Number(balCrystals[0])} Karma Crystals available.</p>
              <div className="stake-cs"><input ref={stakeRef_k}/><button onClick={stakeCrystals_k}>Stake</button></div>
              <p>You have {userAmountStaked_k} Karma Crystals staked.</p>
              <div className="unstake-cs"><input ref={unstakeRef_k}/><button onClick={unstakeCrystals_k}>Unstake</button></div>
              <button className="claim-cs" onClick={claimRewards_k}>Claim $CANDLE</button>
              <button className="approve-cs" onClick={approve4allCS_k}>Approve Cult Crystals</button>
            </div>
          </div>

          <div className={"screen screen--shrines screen-showing--" + isShrinesShowing}>
            <div className="close-screen" onClick={closeShrines}><div>x</div></div>
            <h1>Shrine Center</h1>
            <div className={"subscreen subscreen--shrine-list subscreen-showing--" + isShrineListShowing}>
              <h2 onClick={toggleShrineScreen(0)}>Choose an Active Shrine</h2>
              <div className="subscreen__in">
                <Shrines 
                  active={activeShrine} 
                  choose={(index)=>{
                    return () => {
                      setActiveShrine(index)
                    }
                  }} />
              </div>
            </div>
            <div className={"subscreen subscreen--shrine-purchase subscreen-showing--" + isShrinePurchaseShowing}>
              <h2 onClick={toggleShrineScreen(1)}>Purchase a Shrine</h2>
              <div className="subscreen__in">
                <p>A shrine costs 42 Karma Crystals and 10,000 $CANDLE.</p>
                <p>Shrine Owners receive 99% of the $CANDLE fees they charge.</p>
                <p>Shrine Owners can change the name and fee as often as they like.</p>
                <p>Purchasing a shrine will trigger 3 transactions: Approving the Shrine contract to spend your Crystals, Approving the Shrine contract to spend your $CANDLE, and Purchasing the Shrine.</p>
                <p>Shrines are non-transferrable, they are NOT NFTs.</p>
                <button onClick={purchaseShrine}>Purchase a Shrine</button>
              </div>
            </div>
            <div className={"subscreen subscreen--shrine-manage subscreen-showing--" + isShrineManageShowing}>
              <h2 onClick={toggleShrineScreen(2)}>Manage a Shrine</h2>
              <div className="subscreen__in">
                <button onClick={detectOwnedShrine}>Load Your Shrine</button>
                <div className={"loaded-shrine loaded-shrine--" + isOwnedShrineLoaded}>
                  <p>Welcome back {(accounts.length > 0) ? accounts[0] : ""}</p>
                  <p>Manage {loadedShrineName} // Shrine #{loadedShrineNumber}</p>
                  <p>Change Name: <input ref={shrineNameRef} /><button onClick={updateShrineName}>Update Name</button></p>
                  <p>Change Fee: <input ref={shrineFeeRef} /><button onClick={updateShrineFee}>Update Fee</button></p>
                </div>
              </div>
            </div>
          </div>

          <div className={"screen screen--farm screen-showing--" + isFarmShowing}>
            <div className="close-screen" onClick={closeFarms}><div>x</div></div>
            <div className={"farms farms--" + activePool}>
              <div className="farm">
                <h2>Gated Farms</h2>
                <button onClick={showPool("g0")}>Stake $CULT</button>
                <button onClick={showPool("g1")}>Stake $xCULT</button>
                <button onClick={showPool("g2")}>Stake $CANDLE</button>

                
              </div>
              <div className="farm">
                <h2>RETIRED - (de)genesis Farms</h2>
                <button onClick={showPool("d0")}>Unstake $CULT</button>
                <button onClick={showPool("d1")}>Unstake $xCULT</button>
                <button onClick={showPool("d2")}>Unstake $CANDLE</button>

              </div>
              <div className="farm">
                <h2>RETIRED - Burn Farms</h2>
                <button onClick={showPool("b0")}>Unstake $CULT-FTM</button>
                <button onClick={showPool("b1")}>Unstake $xCULT-FTM</button>
                <button onClick={showPool("b2")}>Unstake $CANDLE-multiUSDC</button>
                <button onClick={showPool("b3")}>Unstake $xCULT-CULT</button>
               <Pool
                  poolUniqueID="g0"
                  poolName="Cult Gated Pool"
                  stakingToken="Cult"
                  tokenImg={tokens["cult"]["icon"]}
                  poolBalance={fs(Number(farm_gate_UserInfo_0.amount))}
                  pendingRewards={fs(Number(farm_gate_PendCand_0))}
                  claim={claim("g0")}
                  closeScreen={closePool} 
                  theInputRef={g0inputRef}
                  stake={stake("g0")}
                  unstake={withdrawAll("g0")}
                  gate="In order to interact with this pool you must have a briefcase"/>
                <Pool
                  poolUniqueID="g1"
                  poolName="xCult Gated Pool"
                  stakingToken="xCult"
                  tokenImg={tokens["xcult"]["icon"]}
                  poolBalance={fs(Number(farm_gate_UserInfo_1.amount))}
                  pendingRewards={fs(Number(farm_gate_PendCand_1))}
                  claim={claim("g1")}
                  closeScreen={closePool}
                  theInputRef={g1inputRef}
                  stake={stake("g1")}
                  unstake={withdrawAll("g1")}
                  gate="In order to interact with this pool you must have an apple"  />
                <Pool
                  poolUniqueID="g2"
                  poolName="Candle Gated Pool"
                  stakingToken="Candle"
                  tokenImg={tokens["candle"]["icon"]}
                  poolBalance={fs(farm_gate_UserInfo_2.amount)}
                  pendingRewards={fs(farm_gate_PendCand_2)}
                  claim={claim("g2")}
                  theInputRef={g2inputRef}
                  closeScreen={closePool}
                   stake={stake("g2")}
                  unstake={withdrawAll("g2")}
                  gate="In order to interact with this pool you must have a briefcase or an apple"  />


                <Pool
                  poolUniqueID="d0"
                  poolName="Cult Degenesis Pool"
                  stakingToken="Cult"
                  poolBalance={fs(farm_degenesis_UserInfo_0.amount)}
                  pendingRewards={fs(farm_degenesis_PendCand_0)}
                  isRetired={true}
                  closeScreen={closePool} />
                
                <Pool
                  poolUniqueID="d1"
                  poolName="xCult Degenesis Pool"
                  stakingToken="xCult"
                  poolBalance={fs(farm_degenesis_UserInfo_1.amount)}
                  pendingRewards={fs(farm_degenesis_PendCand_1)}
                  isRetired={true}
                  closeScreen={closePool} />
                
                <Pool
                  poolUniqueID="d2"
                  poolName="Candle Degenesis Pool"
                  stakingToken="Candle"
                  poolBalance={fs(farm_degenesis_UserInfo_2.amount)}
                  pendingRewards={fs(farm_degenesis_PendCand_2)}
                  isRetired={true}
                  closeScreen={closePool} />
                <Pool
                  poolUniqueID="b0"
                  poolName="Cult-FTM Burn Pool"
                  stakingToken="Cult-FTM"
                  poolBalance={fs(farm_burn_UserInfo_0.amount)}
                  pendingRewards={fs(farm_burn_PendCand_0)}
                  isRetired={true}
                  closeScreen={closePool} />

                
                <Pool
                  poolUniqueID="b1"
                  poolName="xCult-FTM Burn Pool"
                  stakingToken="xCult-FTM"
                  poolBalance={fs(farm_burn_UserInfo_1.amount)}
                  pendingRewards={fs(farm_burn_PendCand_1)}
                  isRetired={true}
                  closeScreen={closePool} />
                
                <Pool
                  poolUniqueID="b2"
                  poolName="Candle-multiUSDC Burn Pool"
                  stakingToken="Candle-multiUSDC"
                  poolBalance={fs(farm_burn_UserInfo_2.amount)}
                  pendingRewards={fs(farm_burn_PendCand_2)}
                  isRetired={true}
                  closeScreen={closePool} />
                
                <Pool
                  poolUniqueID="b3"
                  poolName="xCult-Cult Burn Pool"
                  stakingToken="xCult-Cult"
                  poolBalance={fs(farm_burn_UserInfo_3.amount)}
                  pendingRewards={fs(farm_burn_PendCand_3)}
                  isRetired={true}
                  closeScreen={closePool} />
                
              </div>
            </div>
          </div>

          
 
          <div className={"modal modal--pending screen-showing--" + isPending}>
            <h2>Pending Transaction</h2>
            <div className="modal__inside">
              <p>{pendingText}</p>
              <div className="modal__img"><img src={pending} /></div>  
            </div>
          </div>

          <div className={"connected-address screen-showing--" + connected}>Connected as: {(accounts.length > 0) ? accounts[0] : ""}</div>
      </div>
    </div>
  );
}

export default App;
